export default __webpack_public_path__ + "static/media/node-foursquare-1.f9114859.jpg";